import { render } from "./HeXiao.vue?vue&type=template&id=12921164&scoped=true"
import script from "./HeXiao.vue?vue&type=script&lang=js"
export * from "./HeXiao.vue?vue&type=script&lang=js"

import "./HeXiao.vue?vue&type=style&index=0&id=12921164&scoped=true&lang=css"

import exportComponent from "D:\\hemiao100Code\\hemiao100-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12921164"]])

export default __exports__